import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H2Emphasized,
    Icon,
    Mailbox,
    View,
    YStack,
} from 'smoothie';

interface DifferentAddressProps {
    onPress: () => void;
}

const DifferentAddress = ({ onPress }: DifferentAddressProps) => {
    return (
        <YStack flex={1} justifyContent="space-between">
            <YStack gap={6} alignItems="center">
                <View
                    backgroundColor="$green900"
                    borderRadius={20}
                    padding={20}
                    height={90}
                    width={90}
                    alignItems="center"
                    justifyContent="center"
                    marginBottom={32}
                >
                    <Icon icon={Mailbox} size={40} color="$white" />
                </View>
                <H2Emphasized textAlign="center" marginBottom={8}>
                    Request to use a {'\n'} different address
                </H2Emphasized>
                <BodyMediumRegular textAlign="center" color="$gray1000">
                    For security reasons, we may need to ask {'\n'} some more
                    questions.
                </BodyMediumRegular>
            </YStack>
            <View gap={12}>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    onPress={onPress}
                    size={ButtonSize.LARGE}
                    text="Contact Fruitful Hospitality"
                />
            </View>
        </YStack>
    );
};

export default DifferentAddress;
